import * as Configuration from '../../../app.constants.js';

AddAccountBusinessChatController.$inject = ['$scope', 'TopToolbarFactory', '$stateParams', '$http', 'company', 'AlertingFactory'];
export function AddAccountBusinessChatController($scope, TopToolbarFactory, $stateParams, $http, company, AlertingFactory) {
  $scope.submit = submit;
  init();

  function submit(formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' +
      company.id + '/business-chat/' + $stateParams.requestId + '/extra';
    $http.post(url, formData).then(function success(response) {

      if(response.data.error) {
          let url = response.data.redirect_url + '?error=' + response.data.reason;
          window.location.href = url;
      } else {
          let url = response.data;
          window.location.href = url;
      }
    }, function error(response) {
      AlertingFactory.alertHTTPError(response);
    });
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('add-account/business-chat', $scope);

    $scope.formData = {
      app_name:'',
      app_id: '',
      app_original_id: '',
      app_secret: ''
    };
  }
}
